import React, { useEffect, useRef, useState } from "react";

export default function Countdown({ seconds, onExpire, className = "" }) {
  const [left, setLeft] = useState(Math.max(0, Math.floor(seconds || 0)));
  const firedRef = useRef(false);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    const next = Math.max(0, Math.floor(seconds || 0));
    if (next > 0) firedRef.current = false;
    setLeft(next);
  }, [seconds]);

  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setInterval(() => {
      setLeft((l) => {
        if (l <= 1) {
          if (!firedRef.current) { firedRef.current = true; onExpireRef.current && onExpireRef.current(); }
          return 0;
        }
        return l - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [left]);

  const h = Math.floor(left / 3600);
  const m = Math.floor((left % 3600) / 60);
  const s = left % 60;
  const pad = (n) => String(n).padStart(2, "0");

  if (left <= 0) return <span className={`font-mono text-red-400 ${className}`}>CLOSED</span>;

  return (
    <span className={`font-mono ${className}`}>
      {h > 0 && `${pad(h)}:`}
      {pad(m)}:{pad(s)}
    </span>
  );
}
